import { Checkbox, CheckboxProps } from '@chakra-ui/react';

/**
 * Brand-styled checkbox with indeterminate state support
 */
export const ThemedCheckbox = (props: CheckboxProps) => (
  <Checkbox
    {...props}
    colorScheme="brand"
    borderColor="border-muted"
    sx={{
      '[data-checked]': {
        borderColor: 'brand.500',
        backgroundColor: 'brand.500',
      },
      '[data-indeterminate]': {
        borderColor: 'brand.500',
        backgroundColor: 'brand.500',
      },
    }}
  />
);
